export default __webpack_public_path__ + "static/media/Honda.1e445ccd.svg";